var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5548 29.7238H14.3597V25.5164H22.7746V22.7114H14.3597V19.9065H20.6709C24.5375 19.9065 27.6832 16.7608 27.6832 12.8942C27.6832 9.02757 24.5375 5.88184 20.6709 5.88184H12.9573C12.5853 5.88184 12.2286 6.0296 11.9656 6.29261C11.7026 6.55562 11.5548 6.91235 11.5548 7.2843V17.1016H7.34741V19.9065H11.5548V22.7114H7.34741V25.5164H11.5548V29.7238ZM14.3597 8.68677H20.6709C22.9905 8.68677 24.8783 10.5745 24.8783 12.8942C24.8783 15.2139 22.9905 17.1016 20.6709 17.1016H14.3597V8.68677Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.471229
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/Ruble.f7af330f5d7573e927e2f9feb59a9521.svg";
export { ForwardRef as ReactComponent };